import React from 'react';
import ViewportProvider from '../../context/view-port-provider';
import LandingPageWeb from './../LandingPage';
import UcaNavigation from './../UcaNavigation';
import { useAuth } from '../../context/auth-context-aem';
import Loader from '../../common/Loading/loader';

const LandingPageV2 = () => {
  const { isLoading } = useAuth();
  if (isLoading) return <Loader></Loader>;
  return (
    <ViewportProvider data-testid="viewport-provider">
      <div className="responsivegrid aem-GridColumn aem-GridColumn--default--12">
        <div className="aem-Grid aem-Grid--12 aem-Grid--default--12 ">
          <div className="column-control aem-GridColumn aem-GridColumn--default--12">
            <div className="column-control-wrapper full-bleed-container layout-padding">
              <div className="full-bleed-row">
                <div className="container-fluid">
                  <div className="row">
                    <div className="contentdiv col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 view">
                      <div className="experiencefragment section">
                        <div className="aem-Grid aem-Grid--12 aem-Grid--default--12 ">
                          <div className="responsivegrid aem-GridColumn aem-GridColumn--default--12">
                            <div className="aem-Grid aem-Grid--12 aem-Grid--default--12 ">
                              <UcaNavigation />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="asidediv col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
                      <LandingPageWeb />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ViewportProvider>
  );
};

export default LandingPageV2;
